<template>
  <section v-if="LOCATION">
    <gmap-map :center="LOCATION" :zoom="12" style="width:100%;  height: 75vh;">
      <gmap-marker
        :key="loc.locId"
        v-for="loc in LOCATIONS"
        :position="loc.position"
        :title="loc.locName"
      ></gmap-marker>
    </gmap-map>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["LOCATION", "LOCATIONS"])
  }
};
</script>

<style scoped></style>
